export default {"src":"/_next/static/media/vpn-relay-logo.d5d02afa.svg","height":32,"width":73,"blurWidth":0,"blurHeight":0};